(() => {
  if (window.mcPageSizeChartReady) return;
  window.mcPageSizeChartReady = true;
  const chartLabel = /\b(?:size\s*(?:chart|guide|table)|sizing\s*(?:chart|guide|table)|measurement\s*(?:chart|guide)|maat\s*(?:tabel|gids)|maattabel|größen?\s*tabelle|guide\s*des\s*tailles|tabla\s*de\s*tallas)\b/i;
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  const hide = node => { node.hidden = true; node.setAttribute('data-mc-page-chart-legacy-hidden', ''); };
  function prepare(scope = document) {
    const sections = Array.from(scope.querySelectorAll('[data-mc-page-chart-product]'));
    if (scope.matches?.('[data-mc-page-chart-product]')) sections.unshift(scope);
    sections.forEach(section => {
      const dialog = section.querySelector('[data-mc-page-chart-dialog]');
      if (!dialog) return;
      if (!dialog.dataset.mcPageChartBound) {
        dialog.dataset.mcPageChartBound = 'true';
        dialog.addEventListener('close', () => {
          document.documentElement.classList.toggle('mc-page-chart-open', !!document.querySelector('[data-mc-page-chart-dialog][open]'));
          dialog.mcChartTrigger?.setAttribute('aria-expanded', 'false');
          if (dialog.mcChartTrigger?.isConnected) dialog.mcChartTrigger.focus({ preventScroll: true });
        });
      }
      section.querySelectorAll('.mc-product-description').forEach(description => {
        const headings = Array.from(description.querySelectorAll('h1,h2,h3,h4,h5,h6,p,strong,b,figcaption'));
        description.querySelectorAll('table,[role="table"],img').forEach(node => {
          if (node.parentElement.closest('table,[role="table"]')) return;
          const preceding = headings.filter(h => !h.contains(node) && (h.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)).pop();
          const nearHeading = preceding && chartLabel.test(normalize(preceding.textContent));
          const marked = chartLabel.test(normalize([node.id,node.className,node.getAttribute('alt'),node.getAttribute('src')].join(' '))) || node.hasAttribute('data-size-chart');
          const rows = Array.from(node.querySelectorAll('tr,[role="row"]'));
          const firstRows = rows.slice(0,2).flatMap(row => Array.from(row.querySelectorAll('th,td,[role="columnheader"],[role="cell"]')).map(cell => normalize(cell.textContent))).join(' ');
          const sizes = /\b(?:sizes?|sizing|maat|maten|tallas?|taille|us|uk|eu)\b/i.test(firstRows);
          if (!marked && !nearHeading && !sizes) return;
          hide(node);
          if (nearHeading) hide(preceding);
        });
      });
      const triggers = section.querySelectorAll('[data-mc-page-chart-open]');
      if (!triggers.length) {
        const label = section.querySelector('.variant__label--size') || section.querySelector('.product-single__form') || section.querySelector('.product-block--header');
        if (label) {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'mc-inline-size-guide-button';
          button.setAttribute('data-mc-page-chart-open','');
          button.setAttribute('aria-controls',dialog.id); button.setAttribute('aria-haspopup','dialog'); button.setAttribute('aria-expanded','false');
          button.textContent = dialog.querySelector('.mc-page-chart__header p').textContent;
          label.append(button);
        }
      }
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-mc-page-chart-open]');
    if (trigger) {
      const section = trigger.closest('[data-mc-page-chart-product]');
      const dialog = section?.querySelector('[data-mc-page-chart-dialog]');
      if (!dialog) return;
      event.preventDefault(); event.stopImmediatePropagation();
      prepare(section); dialog.mcChartTrigger = trigger;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('mc-page-chart-open'); trigger.setAttribute('aria-expanded','true');
      return;
    }
    const close = event.target.closest('[data-mc-page-chart-close]');
    if (close) { event.preventDefault(); close.closest('dialog').close(); return; }
    const unit = event.target.closest('[data-mc-page-chart-unit]');
    if (unit) {
      event.preventDefault(); const dialog = unit.closest('dialog');
      dialog.querySelectorAll('[data-mc-page-chart-unit]').forEach(button => button.setAttribute('aria-pressed',String(button===unit)));
      dialog.querySelectorAll('[data-mc-page-chart-panel]').forEach(panel => {panel.hidden=panel.dataset.mcPageChartPanel!==unit.dataset.mcPageChartUnit;});
      return;
    }
    if (event.target.matches('[data-mc-page-chart-dialog]')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  }, true);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>prepare(),{once:true});
  else prepare();
})();
